import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@glplus/glpweb-dsl';
import { KitDisclaimer } from '../kit/Disclaimer';
import { Estimator } from '../kit/tools/Estimator';
import { Checklist } from '../kit/tools/Checklist';

export default function KitTools() {
  const { t } = useTranslation();
  return (
    <Box data-testid="page-kit-tools" sx={{ maxWidth: 900 }}>
      <Typography component={Link} to="/kit" sx={{ color: '#1f7a3d', fontWeight: 600, fontSize: 13, textDecoration: 'none', display: 'inline-block', mb: 1.5 }}>{t('kit.back')}</Typography>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 800, color: '#1f2937', fontSize: { xs: '24px', md: '30px' }, mb: 2 }}>{t('kit.tools.title')}</Typography>
      <KitDisclaimer />
      <Box id="estimator" sx={{ mb: 3 }}><Estimator /></Box>
      <Box id="checklist"><Checklist /></Box>
    </Box>
  );
}
